import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-documento-cargado',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './update-documento-cargado.component.html',
  styleUrl: './update-documento-cargado.component.css',
})
export class UpdateDocumentoCargadoComponent implements OnInit {
  idDocumentoCargado: number = 0;
  documentoData: any = {};
  nombre: string = '';
  linkArchivo: string = '';
  idInstitucionEducativa: number = 0;
  errorArchivo: string = ''; // Variable para almacenar errores de archivo
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.idDocumentoCargado = params['id_documento_cargado'];
      if (isNaN(this.idDocumentoCargado) || this.idDocumentoCargado <= 0) {
        console.error(
          'idDocumentoCargado no es un número válido:',
          this.idDocumentoCargado
        );
      }
    });
    this.loadUserData();
  }

  loadUserData(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      this.idInstitucionEducativa = user.id_institucion_educativa || 0;
    } else {
      console.error('No se encontró información de usuario en localStorage.');
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.errorArchivo = ''; // Limpiar mensajes de error previos

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);

      this.http
        .post<{ url: string }>(
          environment.apiUrl +'/archivo?fileName='+this.idDocumentoCargado+this.idInstitucionEducativa,
          formData
        )
        .subscribe(
          (response) => {
            this.linkArchivo = environment.serverUrl + response.url; // Asigna el link del archivo al input
            Swal.fire(
              'Éxito',
              'El archivo se ha cargado con exito',
              'success')
            //alert('Archivo subido con éxito');
          },
          (error) => {
            console.error('Error al subir el archivo:', error);
            this.errorArchivo =
              error.error.message || 'Error al subir el archivo.';
          }
        );
    }
  }

  saveDocumentoCargado(): void {
    const payload = {
      link_archivo: this.linkArchivo,
      estado: 'RECTIFICADO',
    };
    this.http
      .patch(
        environment.apiUrl +'/documento-cargado/' +
          this.idDocumentoCargado,
        payload
      )
      .subscribe(
        (response) => {
          //alert('Documento cargado con exito');
          Swal.fire('Éxito', 'Documento cargado con exito', 'success');
          // console.log(response);
          this.registrarHistorial(
            'RECTIFICADO',
            this.linkArchivo,
            this.idDocumentoCargado
          );
          this.router.navigate(['/documentos-institucion']);
        },
        (error) => {
          console.error('Error al guardar el documento cargado:', error);
        }
      );
  }

  registrarHistorial(
    estado: string,
    link_archivo: string,
    id_documento_cargado: number
  ): void {
    id_documento_cargado = Number(id_documento_cargado);
    const body = {
      accion: estado,
      link_archivo: link_archivo,
      id_documento_cargado: id_documento_cargado,
    };

    this.http
      .post(environment.apiUrl + '/historial-institucion', body)
      .subscribe(
        (response) => {
          // console.log('Historial registrado con éxito:', response);
        },
        (error) => {
          console.error('Error al registrar el historial:', error);
        }
      );
  }

  goBack(): void {
    this.location.back();
  }
}
